import styled, { css } from 'styled-components/macro';
import { defaultContainer } from '../../styles/utils';
import { TabsDiv, TabNavLink } from '../../components/TabStyles';
import { DefaultIcon } from '../../components/Icon';
import { BlueTextLink } from '../../components/LinkStyles';
import { PageHeaderP } from '../../components/PageHeaderStyles';

export const MerchantsDiv = styled.div`
  position: relative;
  ${props =>
    !props.showMostRecentOnly &&
    css`
      ${defaultContainer}
    `}
`;

export const MerchantsNavHeaderDiv = styled.div`
  ${defaultContainer}
  padding-top: 5rem;
  @media screen and (max-width: 767px) {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  ${TabsDiv} {
    margin-left: 0;
  }
  ${TabNavLink} {
    @media screen and (max-width: 767px) {
      padding: 0.8rem 0.5rem;
    }
  }
`;

export const CustomPageHeaderP = styled(PageHeaderP)`
  @media screen and (max-width: 768px) {
    && {
      margin-bottom: 25px;
    }
  }
`;

export const CustomBlueTextLink = styled(BlueTextLink)`
  @media screen and (max-width: 768px) {
    padding-left: 0;
  }
`;

export const FailedMerchantRegistrationsErrorMessage = styled.div`
  display: flex;
  align-items: center;

  ${DefaultIcon} {
    height: 18px;
    width: 18px;
    margin-right: 5px;
  }
  margin-bottom: 25px;

  padding-bottom: 10px;
  @media screen and (min-width: 768px) {
    ${defaultContainer};
    position: absolute;
    right: 0;
    top: 64px;
    > div {
      display: flex;
    }
  }
  @media screen and (min-width: 1024px) {
    top: 81px;
  }
  @media screen and (min-width: 1440px) {
    top: 88px;
  }
  @media screen and (min-width: 1624px) {
    top: 75px;
  }
`;
